import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ORDERS_ACTIVE_WORKS } from "../../../configs/api-config";
import userSelectors, { ordersNeedsActionSelector } from "../selectors";
import useReduxSwr from "../../global/hooks/useReduxSwr";
import { Order } from "../../../types/server";
import { set_orders_needs_action_action } from "../actions";

export default useOrdersNeedsActionList;

function workDoneListApi() {
  return axios.get(ORDERS_ACTIVE_WORKS).then((res) => {
    return res.data;
  });
}

function useOrdersNeedsActionList() {
  let authenticated: boolean = useSelector(userSelectors.getToken);
  let dispatch = useDispatch();
  let {
    data: ordersState,
    isValidating,
    revalidate: revalidateOrders,
  } = useReduxSwr<{ data: Order[] }>({
    fetcher: workDoneListApi,
    selector: ordersNeedsActionSelector,
    onFinished: (data) => {
      dispatch(set_orders_needs_action_action(data));
    },
    enabled: false,
  });

  useEffect(() => {
    // Only run 1 time
    // If data is undefined, we will try to get the data
    if (!isValidating && authenticated && !ordersState) {
      revalidateOrders();
    }
  }, []);

  return {
    data: ordersState?.data || [],
    loading: isValidating,
    revalidate: revalidateOrders,
  };
}
